import React from 'react'
import './experiences.css'
import { AiFillHtml5 } from 'react-icons/ai'
import { FaBootstrap, FaAngular, FaReact, FaNodeJs } from 'react-icons/fa'
import { IoLogoJavascript } from 'react-icons/io'
import { DiCss3, DiMongodb, DiJava } from 'react-icons/di'
import { SiPhp, SiMysql, SiSpringboot } from 'react-icons/si'

const Experiences = () => {
  return (
    <section id='experiences'>
      <h5>Mes différentes compétences</h5>
      <h2>Mes expériences</h2>
      <div className='container experience_container'>
        <div className='experience_frontend'>
          <h3>Frontend Developement</h3>
          <div className='experience_content'>
            <article className='experience_details'>
              <AiFillHtml5 className='experience_details-icon-html'></AiFillHtml5>
              <div>
                <h4>HTML</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <FaBootstrap className='experience_details-icon-bootstrap'></FaBootstrap>
              <div>
                <h4>Bootstrap</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <IoLogoJavascript className='experience_details-icon-js'></IoLogoJavascript>
              <div>
                <div>
                  <h4>JavaScrpt</h4>
                </div>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <FaAngular className='experience_details-icon-angular'></FaAngular>
              <div>
                <h4>Angular</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <FaReact className='experience_details-icon-react'></FaReact>
              <div>
                <h4>React</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <DiCss3 className='experience_details-icon-css'></DiCss3>
              <div>
                <h4>CSS</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
          </div>
        </div>

        {/* End of front */}

        <div className='experience_backend'>
          <h3>Backend Developement</h3>
          <div className='experience_content'>
            <article className='experience_details'>
              <FaNodeJs className='experience_details-icon-nodeJS'></FaNodeJs>
              <div>
                <h4>Node JS</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <DiMongodb className='experience_details-icon-mongoDB'></DiMongodb>
              <div>
                <h4>Mongo DB</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <SiPhp className='experience_details-icon-php'></SiPhp>
              <div>
                <h4>PHP</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <SiMysql className='experience_details-icon-sql'></SiMysql>
              <div>
                <h4>MySql</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <SiSpringboot className='experience_details-icon-springBoot'></SiSpringboot>
              <div>
                <h4>SpringBoot</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
            <article className='experience_details'>
              <DiJava className='experience_details-icon'></DiJava>
              <div>
                <h4>Java</h4>
                <small>2ans d'exp.</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experiences
